<template>
  <div id="comments-container">
    <comments ref="qaComments"></comments>
  </div>
</template>

<script>
require('@/assets/css/bootstrap-social.css')
require('@/assets/css/sweetalert2.min.css')
require('@/assets/css/materialdesignicons.min.css')
require('@/assets/css/font-awesome.min.css')

import store from '@/vuex'
import auth from '@/api/auth'
import { mapActions, mapGetters } from 'vuex'
import Comments from '@/components/Comments.vue'
import cookies from '@/utilities/cookies'

const Promise = window.Promise || require('promise')

const cleanup = (store) => {
  cookies.set('bhunterToken', '', { expires: -1 })
  store.dispatch('users/setToken', '', { root: true })
  store.dispatch('users/setData', { uid: 0 }, { root: true })
  store.dispatch('users/tirggerAuthCheck', false, { root: true })
}

const authCheck = (store, token) => {
  return auth.check(token)
    .then(data => {
      cookies.set('bhunterToken', data.token, { expires: 86400 })
      store.dispatch('users/setToken', data.token, { root: true })
      store.dispatch('users/setData', data.user, { root: true })
      store.dispatch('users/tirggerAuthCheck', true, { root: true })
      return Promise.resolve()
    }, () => {
      cleanup(store)
      return Promise.resolve()
    })
}

export default {
  name: 'comments-container',
  components: {
    comments: Comments
  },
  beforeMount () {
    let alias = location.pathname.split('/')
      .reduce((carry, path) => {
        if (path !== '') {
          carry = carry.concat([path])
        }
        return carry
      }, [])
    let locale = 'tw'
    if (alias.length > 0) {
      if (['tw', 'en', 'jp', 'th'].indexOf(alias[0]) > -1) {
        locale = alias[0]
        if (String(alias[1]).length > 0) {
          alias = alias[1]
        } else {
          alias = false
        }
      } else {
        alias = false
      }
    } else {
      alias = false
    }

    if (alias) {
      let token
      if (store.state.users.token !== '' &&
        typeof store.state.users.token !== 'undefined'
      ) {
        token = [store.state.users.token]
      } else {
        let query
        try {
          query = window.location.search.substring(1)
          query = JSON.parse('{"' + decodeURIComponent(query).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
        } catch (e) {}
        if (typeof query !== 'undefined') {
          if (typeof query.token !== 'undefined') {
            token = query.token.match(/^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*/gim)
          }
        }
      }

      if (token !== null && Array.isArray(token)) {
        if (typeof token[0] !== 'undefined') {
          authCheck(store, token[0])
            .then(() => {
              this.fetchBuilderAndComments(locale, alias)
            })
        } else {
          cleanup(store)
          this.fetchBuilderAndComments(locale, alias)
        }
      } else {
        token = cookies.get('bhunterToken')
        if (typeof token !== 'undefined') {
          authCheck(store, token)
            .then(() => {
              this.fetchBuilderAndComments(locale, alias)
            })
        } else {
          cleanup(store)
          this.fetchBuilderAndComments(locale, alias)
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      getBuilder: 'builder/getBuilder'
    })
  },
  methods: {
    fetchBuilderAndComments (locale, alias) {
      this.fetchBuilder({
        locale: locale,
        alias: alias
      }).then(() => {
        let comment = 0
        if (typeof window.location.search !== 'undefined') {
          let search = window.location.search.replace('?', '')
          search.split('&').every(item => {
            let keyValue = item.split('=')
            if (keyValue[0].toLowerCase() === 'comment') {
              if (typeof keyValue[1] !== 'undefined') {
                comment = parseInt(keyValue[1], 10)
                return false
              }
            }
          })
        }
        this.fetchComments({
          parent: 0,
          page: 1,
          loadMore: false,
          comment: comment
        }).then(res => {
          this.$refs.qaComments.$emit('toggleHighlightComment', res.highlightComment)
        })
      })
    },
    ...mapActions({
      fetchBuilder: 'builder/fetchBuilder',
      fetchComments: 'builder/fetchComments'
    })
  }
}
</script>

<style lang="sass">
@import './assets/variables.sass'

#comments-container
  @import './assets/stylesheets/bootstrap-mincer'
  @import './assets/stylesheets/bootstrap'

#comments-container
  .card
    position: relative
    margin-bottom: 10px
    &--list
      margin-bottom: 20px
      &:hover
        .card__top.cover-img a
          +opacity(1)
        .counts-group
          right: 10px
          +opacity(1)
          @media screen and (max-width: $breakpoint-sm)
            right: 10px
            top: 10px
            +opacity(1)
          @media screen and (max-width: $breakpoint-xs)
            right: 0
            top: 0
            +opacity(1)
    &:after
      +transition(all, 0.3s)
    &--with-animation, &--hide
      +opacity(0)
      transform: transleteY(0)
      +transition(all, 0.3s)
    &--animated
      +opacity(1)
      transform: translateY(5px)
    &--disabled
      cursor: not-allowed
      &:after
        content: ''
        position: absolute
        display: block
        width: 100%
        height: 100%
        background-color: rgba($background,0.8)
      &:hover
        box-shadow: 0 1px 2px rgba(0,0,0,0.15) !important
    &-default
      padding: 10px
      background-color: $white
    &-invert
      padding: 10px
      background-color: #e3e3e3
      // border: 1px solid $border
      box-shadow: 0 1px 2px rgba(#888,0.5)
      &.inset
        box-shadow: inset 0 1px 2px rgba(#888,0.5)
    &.card-flat
      box-shadow: none !important
    &.no-padding
      padding: 0
      > ul
        padding: 10px
    &.border-radius
      +border-radius(3px)
      +clearfix
    input:focus
      box-shadow: none
    .card__extra-top
      background-color: $background
      .btn.btn-blank.pull-left
        padding: 4px 6px
      .title
        font-size: $font-size-4
        color: $brown-1
        &.title--with-padding
          padding: 6px
        &.actived
          color: $black
    .card__top
      &.cover-img
        width: 226px
        height: 170px
        position: relative
        @media screen and (max-width: $breakpoint-xs)
          width: 30%
          height: auto
        a
          display: block
          min-height: 100%
          background:
            color: #eee
            size: cover
            position: center center
            repeat: no-repeat
          padding-top: 74.5283%
          +opacity(0.7)
          +transition(opacity, 0.5s)
          @media screen and (max-width: $breakpoint-sm)
            +opacity(1)
          &.cover-img--default
            background-image: url('./assets/cover_640x480.png')
      @media screen and (max-width: $breakpoint-xs)
        padding: 10px 6px 10px 10px
        // width: 100%
        // height: auto
    .card__content
      padding: 10px 10px
      background-color: $white
      &.no-cover
        max-width: 540px
        padding: 14px 14px
        @media screen and (max-width: $breakpoint-xs)
          // max-width: 100%
        .title
          max-width: 540px

      @media screen and (max-width: $breakpoint-md)
        // min-width: 350px
        max-width: 350px
      @media screen and (max-width: $breakpoint-xs)
        width: 70%
        min-width: 70%
        padding: 3px 3px 3px 0
        div:not(.title)
          text-align: right
      a:hover
        color: $black
      .title
        font-size: $font-size-3
        font-weight: normal
        color: $black
        margin-bottom: 4px
        max-width: 440px
        @media screen and (max-width: $breakpoint-xs)
          font-size: 3vw
          height: 4.6vw
          overflow: hidden
          text-overflow: ellipsis
          font-weight: bold
          margin-bottom: 1px
          // max-width: 100%
          // padding-top: 30px
      .card__tag__wrap
        @media screen and (max-width: $breakpoint-xs)
          display: none
      ul
        color: #999
        font-size: 13px
        li > span:first-child
          font-weight: normal
          @media screen and (max-width: $breakpoint-xs)
            font-size: 1.5vw
    .counts-group
      position: absolute
      right: 10px
      top: 10px
      +transition(all,0.25s)
      +opacity(1)
      @media screen and (max-width: $breakpoint-xs)
        position: relative
        text-align: left !important
        top: initial
        right: initial
        bottom: initial
        left: initial
        .counts-wrap
          display: inline-block
          margin-left: 3px
          font-size: 12px
          &:first-child
            margin-left: 0
    .counts-wrap
      color: $brown-1
      i
        margin-right: 3px

    .card__extra
      &--block
        clear: both
      &--float
        position: absolute
        bottom: 10px
        right: 10px
      @media screen and (max-width: $breakpoint-sm)
        .btn__heart
          background-color: rgba(white,0.3)
          border-color: rgba($border, 0.3)
          padding: 3px 8px
          i
            vertical-align: text-top
          span
            display: none
    .card__extra ~ .counts-group
      @media screen and (max-width: $breakpoint-sm)
        display: none
    &--small
      padding: 10px !important
      &:not(:last-child)
        margin-bottom: 0
      &:hover
        box-shadow: none
        background-color: $disabled-bg
        .card__content
          background-color: $disabled-bg
      .card
        &__top
          width: 20% !important
          padding: 3px 10px 3px 0px
        &__content
          width: 80%
          padding: 0
          min-width: 70%
          .title
            font-size: 1.2em
            overflow: hidden
            text-overflow: ellipsis
            max-height: 1.2em
            min-height: 1.2em
          .card__tag
            display: none
          .competition-info
            .totalPrize
              display: none

    &--straight
      // +transform(scale(0.98))
      &.card--list
        margin-bottom: 20px
        padding: 0 6px
        box-shadow: none
        background-color: transparent
        &:hover
          .card__top.cover-img a
            +opacity(1)
        .card__tag
          padding: 2px 3px
          margin-bottom: 8px
          font-size: 12px
          @media screen and (max-width: $breakpoint-sm)
            padding: 1px 6px
            margin-bottom: 10px
            font-size: inherit
        .counts-group
          right: -5px !important
          top: 0 !important
          +opacity(0)
          @media screen and (max-width: $breakpoint-sm)
            right: 0px !important
            top: 0px !important
            +opacity(1)
        &:hover
          .counts-group
            right: 0 !important
            top: 0 !important
            +opacity(1)
      .card__top
        width: 100%
        height: auto
        padding: 0
        &.cover-img
          width: 100%
          height: auto
          background-color: $white
          a
            display: block
            min-height: 100%
            background:
              color: transparent
              size: cover
              position: center center
              repeat: no-repeat
            padding-top: 74.5283%
            +opacity(0.7)
            @media screen and (max-width: $breakpoint-sm)
              +opacity(1)
            &.cover-img--default
              color: #eee
              background-image: url('./assets/cover_640x480.png')
      .card__content
        width: 100%
        min-width: 100%
        padding: 10px
        .title
          height: 3.05em
          overflow-y: hidden
          text-overflow: ellipsis
          margin-bottom: 10px
          display: inline-block
          @media screen and (max-width: $breakpoint-sm)
            font-size: 20px
            height: 32px
        div:not(.title)
          text-align: right
        .card__tag__wrap
          display: block
          text-align: left !important
      .counts-group
        position: absolute
        top: 0
        right: 0
        +opacity(1)
        background-color: rgba($white,0.6)
        .counts-wrap
          padding: 10px
          float: left
          color: $black

      .card__extra
        position: relative
        clear: both
        bottom: inherit
        right: inherit
        .btn-group
          display: block
          .btn
            background-color: #FFF
            display: block
            border-radius: 0
            border: none
            border-top: 1px solid #eee
            padding: 8px 6px
            &:first-child
              width: 70%
            &:last-child
              width: 30%
            &:only-child
              width: 100%
            &+ .btn
              margin-left: 0
            @media screen and (max-width: $breakpoint-xs)
              padding: 13px
              &:first-child
                width: 30%
              &:last-child
                width: 70%
              &+ .btn
                margin-left: 0
              &:only-child
                width: 100%
          .btn__heart
            span
              display: inline
</style>




// WEBPACK FOOTER //
// src/App.vue